<template>
	<div class="footers">
		<footer class="main-footer">
			<div class="row">
				<div class="columns column4">
					<h4>{{ defaults[locale].website.restaurantName }}</h4>
					<p class="address">
						<span>{{ defaults[locale].website.street }} {{ defaults[locale].website.number }}</span>
						<span>{{ defaults[locale].website.postalCode }} {{ defaults[locale].website.city }}</span>
						<span>{{ defaults[locale].website.country }}</span>
					</p>
					<p>
						<a :href="`tel:${$phoneRaw(defaults[locale].website.phone)}`">
							<span>{{ defaults[locale].website.phone }}</span>
						</a>
						<a :href="`mailto:${defaults[locale].website.email}`">
							<span>{{ defaults[locale].website.email }}</span>
						</a>
					</p>
				</div>
				<div class="columns column4">
					<h4>{{ $t('quickLinks') }}</h4>
					<p>
						<nuxt-link v-for="item in footermenu[locale]" :key="item.filename" :to="item.filename">
							{{ item.header }}
						</nuxt-link>
					</p>
				</div>
				<div class="columns column4">
					<h4>{{ $t('openingHours') }}</h4>
					<div v-parse-links v-html="defaults[locale].homepage.openingHours" />
				</div>
			</div>
		</footer>
		<footer class="author-footer">
			<div class="row">
				<div class="columns column12">
					<div class="border" />
					<p>
						<a
							class="author-link"
							href="https://www.deliciousdomain.com"
							target="_blank"
							rel="noopener noreferrer"
							title="Restaurant webdesign by Delicious Domain"
						>
							<span class="visually-hidden"> Restaurant webdesign by Delicious Domain </span>
							<span
								role="img"
								aria-hidden="true"
								class="author-logo"
								v-html="DeliciousDomainAuthorLogo"
							/>
						</a>
					</p>
				</div>
			</div>
		</footer>
	</div>
</template>

<script setup>
import DeliciousDomainAuthorLogo from '~/assets/images/author-logo-delicious-domain-currentcolor-except-icon.svg?raw';

const { data: footer } = await useWebsiteFetch('footermenu');
const { footermenu } = footer.value;
const { locale } = useI18n();

const { defaults, fetchDefaults } = useDefaults();

if (!defaults.value) {
	await fetchDefaults();
}
</script>

<style lang="scss" scoped>
.footers {
	color: #fff;
	background: var(--footer-background-color);

	a,
	span {
		color: var(--footer-color);
		text-decoration: none;
	}

	h3,
	h4 {
		color: var(--footer-color);
		letter-spacing: 1px;
	}

	h4 {
		font-family: var(--body-font-family);
		font-size: 1em;
	}
}

.main-footer {
	padding: 75px 0;

	p,
	:deep(p) {
		font-size: 0.8em;
	}

	a,
	span {
		display: block;
	}

	a:hover {
		text-decoration: underline;
	}

	.footer-logo {
		max-width: 180px;
		margin: 0 0 30px;
	}
}

.author-footer {
	font-size: 0.8em;
	padding: 5px 0;
	text-align: center;
	width: 100%;

	p {
		margin: 15px 0;
	}

	.border {
		background: var(--secondary-background-color);
		width: 100%;
		height: 1px;
	}

	img {
		max-width: 90px;
		margin: -1px 1px 3px 2px;
	}

	.author-logo {
		display: inline-block;
		line-height: 0;
		max-width: 200px;

		&:hover {
			color: var(--brown);
		}

		:deep(svg) {
			display: block;
			width: 100%;
			height: auto;
		}
	}

	.visually-hidden {
		position: absolute !important;
		width: 1px;
		height: 1px;
		padding: 0;
		margin: -1px;
		overflow: hidden;
		clip-path: inset(50%);
		white-space: nowrap;
		border: 0;
	}
}

@media (max-width: 1080px) {
	footer .columns {
		margin: 20px 0;
	}

	.author-footer {
		padding-bottom: 40px;
	}
}

@media (max-width: 640px) {
	.main-footer {
		padding: 30px 5px;
	}
}
</style>
